import { render, staticRenderFns } from "./addArticle.vue?vue&type=template&id=1900ee48&scoped=true&"
import script from "./addArticle.vue?vue&type=script&lang=js&"
export * from "./addArticle.vue?vue&type=script&lang=js&"
import style0 from "./addArticle.vue?vue&type=style&index=0&id=1900ee48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1900ee48",
  null
  
)

export default component.exports